import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { SidebarContext } from 'context/SidebarContext';
import DriverServices from 'services/DriverServices';
import { notifyError, notifySuccess } from 'utils/toast';

const useDriverSubmit = (id, selectedLanguagess) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
  const [step, setStep] = useState(1);
  const [driverImageUrl, setDriverImageUrl] = useState('');
  const [licenseImageUrl, setLicenseImageUrl] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState('');
  const [selectedRadioValueGender, setSelectedRadioValueGender] = useState('');
  const [selectedReferenceNo, setSelectedReferenceNo] = useState('');
  const [result,setResult]=useState([])
  const [langId,setLangId]=useState([])
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, setValue, clearErrors, trigger, formState: { errors } } = useForm();

  const handleCountryChange = (country_code, country_id) => {
    setSelectedCountryId(country_id);
    setSelectedCountryCode(country_code);
  };

  const handleStateChange = (state_id) => {
    setSelectedState(state_id);
  };

  const handleCityChange = (city_id) => {
    setSelectedCity(city_id);
  };

  const handleChangeRadioGender = (value) => {
    setSelectedRadioValueGender(value);
  };
  const validateImage=()=>{
    // if(driverImageUrl===""&&step===1){
    //   errors.driverImageUrl={type:'required',message:"Driver Image is required!"};
    // }
    // else {
    //   delete errors.driverImageUrl;
    //  }
    //  if(licenseImageUrl===""&&step===2){
    //   errors.licenseImageUrl={type:'required',message:"License Image is required!"};
    // }
    // else {
    //   delete errors.licenseImageUrl;
    //  }
    
      };

  const validatelanguage = () => {
  if (selectedLanguages.length === 0) {
    errors.selectedLanguages = { type: 'required', message: "Select at least one language!" };
  }
  else {
    delete errors.selectedLanguages;
   }
  };

  const handleReferenceChange = (reference_id) => {
    setSelectedReferenceNo(String(reference_id)); // Converts the value to a string
  };

  const handleNextStep = async () => {
    await Promise.all([validateForm(), validateImage(),validatelanguage()]);
    if (Object.keys(errors).length === 0) {
      if (step !== 2) {
        setStep(step + 1);
      }
    } else {
      return notifyError('Please fill required fields');
    }
  };


  const handlePreviousStep = async () => {
    await Promise.all([validateForm(), validateImage(), validatelanguage()]);
   
      setStep(step - 1);
   
  };

  const goToStep = async (stepNumber) => {
    await Promise.all([validateForm(), validateImage()]);
    if (Object.keys(errors).length === 0) {
      setStep(stepNumber);
    } else {
      return notifyError('Please fill required fields');
    }
  };

  const validateForm = async () => {
    await trigger();
    return Object.keys(errors).length;
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const payload = {
        vendor_id: selectedReferenceNo,
        driver_name: data.driver_name,
        driver_contact_no: data.driver_contact_no,
        driving_license: data.driving_license,
        license_img: licenseImageUrl,
        aadhaar_no: data.aadhaar_number,
        language_known: selectedLanguages, // Include selected languages
        driver_img: driverImageUrl,
      };

      setIsSubmitting(true);

      if (id) {
        const res = await DriverServices.updateDriver(id, payload);
        notifySuccess(res.message);
      } else {
        const res = await DriverServices.addDriver(payload);
        notifySuccess(res.message);
      }

      setIsUpdate(true);
      setIsSubmitting(false);
      closeDrawer();
    } catch (err) {
      notifyError(err?.response?.data?.message || err.message);
      setIsSubmitting(false);
      //closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const result = await DriverServices.getDriverById(id);

          if (result && result.data) {
            const res = result.data;
            const languagesKnown = res.language_known || []; // Default to empty array if undefined

            setSelectedLanguages(languagesKnown); // Set the selected languages state
            setResult(result.data)
            setLicenseImageUrl(res.license_img);
            setLangId(res.langs_id)
            setDriverImageUrl(res.driver_img);
            setSelectedReferenceNo(String(res.vendor_id)); // Convert to string
            setSelectedCity(res.city);
            setSelectedState(res.state);
            setSelectedCountryId(res.country);
            setSelectedRadioValueGender(res.gender);
            setValue('driver_name', res.driver_name);
            setValue('driver_contact_no', res.driver_contact_no);
            setValue('aadhaar_number', res.aadhaar_no);
            setValue('driving_license', res.driving_license);
            setValue('vendor_id', res.vendor_id); // Set vendor_id
          }
        } catch (err) {
          notifyError(err ? err?.response?.data?.message : err.message);
        }
      })();
    }
    else{
      setStep(1);
      setValue('vendor_id', '');
      setValue('driver_name', '');
      setValue('driver_contact_no', '');
      setValue('aadhaar_number', '');
      setValue('driving_license', '');
      setLicenseImageUrl('');
      setDriverImageUrl('');
      setSelectedReferenceNo(String(''));
      setSelectedCity('');
      setSelectedState('');
      setSelectedLanguages([]);
      setSelectedCountryId('');
      setSelectedRadioValueGender('');
    }


    if (!isDrawerOpen) {
     
        setStep(1);
        setValue('vendor_id', '');
        setValue('driver_name', '');
        setValue('driver_contact_no', '');
        setValue('aadhaar_number', '');
        setValue('driving_license', '');
        setLicenseImageUrl('');
        setDriverImageUrl('');
        setSelectedReferenceNo(String(''));
        setSelectedCity('');
        setSelectedState('');
        setSelectedLanguages([]);
        setSelectedCountryId('');
        setSelectedRadioValueGender('');
    
      clearErrors(); 
    }
  }, [id, setValue, isDrawerOpen, clearErrors]);



  return {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    errors,
    handleNextStep,
    selectedLanguages,
    step,
    setStep,
    handlePreviousStep,
    goToStep,
    setSelectedRadioValueGender,
    setSelectedCity,
    setSelectedState,
    setSelectedCountryId,
    setSelectedCountryCode,
    setLicenseImageUrl,
    setDriverImageUrl,
    setSelectedLanguages,
    driverImageUrl,
    licenseImageUrl,
    isSubmitting,
    result,
    selectedCity,
    selectedState,
    selectedCountryId,
    selectedCountryCode,
    selectedRadioValueGender,
    selectedReferenceNo,
    handleChangeRadioGender,
    handleCityChange,
    handleCountryChange,
    handleStateChange,
    handleReferenceChange,loading,setLoading,

    setLangId,
    langId
  };
};

export default useDriverSubmit;
